import { defaultPageProps } from '../../../app/browser/analyticsDefaultProperties';

export default {
  page: {
    name: 'SP : Deals',
    properties: {
      ...defaultPageProps,
      userType: 'Authenticated',
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/store/browser/dealAnalytics.js